import { useNavigate } from 'react-router-dom';
import { Globals as OldGlobals} from '../../global/Globals';
import axios from '../../services/axiosInstance';
import { validateSocialMediaLinks } from '../../util/util';
import CryptoUtils from '../../util/cryptoUtils';
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';
const { useEffect, useState } = require("react");
let producerId=OldGlobals.producerId;

const Unsolicited = ({
    proposalTitle,
    productionType,
    channel,
    cluster,
    country,
    noOfEpisodes,
    noOfMiniEpisodes,
    projectStatus,
    scriptedUnscripted,
    genre,
    newGenre,
    language,
    targetAudience,
    format,
    duration,
    totalDuration,
    totalMiniDuration,
    currency,
    episodeDuration,
    episodeMiniDuration,
    synopsis,
    logline,
    targetBudget,
    productionSchedule,
    episodeStructureOutline,
    locationStudioInfo,
    castPresenterInfo,
    brandIntegrationOpportunities,
    keyTeam,
    artistName,
    songName,
    socialLinks,
    languageIds,
    genreIds,
    channelIds,
    countryIds,
    formatIds,
    currencyIds,
    clusterIds,
    productionTypeIds,
    targetAudienceIds,
    formatTypes,
    scriptTypesIds,
    proposalId,
    proposalDetailId,
    videoFile,
    pdfFile
}) => {
    const { Globals } = useLanguage();
    const [errors, setErrors] = useState({});
    const [loading,setLoading]=useState(false);
    const [header,setactiveHeader]=useState(false)
    const [popUpState, setPopUpState] = useState({
        open: false,
        title: '',
        text: '',
        negativeAction:null,
        normalAction:null,
        negativeActionText:'',
        normalActionText:'',
    });
    const navigate = useNavigate();
    const [isRegFailed, setRegFailure] = useState(false);
    const gotoMyProposals = (success=false,draft=false,discard=false) => {
        if(success){
            navigate(OldGlobals.NAVPATH.HOME, { state: { activeHeader: "proposals",success,draft,discard,user: "producer" }})
            return;
        }
        // navigate(Globals.NAVPATH.HOME, { state: { activeHeader: "proposals" }})
        // navigate(Globals.NAVPATH.HOME+"?activeHeader=proposals");
    }

    const openPopUp = (popUpType="Submit",updateFlag=false) => {
        if(popUpType === "Abort"){
            setPopUpState({
                open: true,
                title: Globals.DISCARD_PROPOSAL_PROMPT_TITLE,
                text: Globals.DISCARD_PROPOSAL_PROMPT,
                negativeAction: gotoMyProposals,
                negativeActionText: Globals.DISCARD,
            });
            return;
        }
        // if (Object.keys(validateFields()).length > 0) {
        //     return;
        // }
        if(popUpType === "Submit"){
            setPopUpState({
                open: true,
                title: Globals.SUBMIT_UNSOLICITED_PROPOSAL_PROMPT_TITLE,
                text: Globals.SUBMIT_PROPOSAL_PROMPT +" "+channel+"?",
                normalAction: updateFlag?updateUnsolicitedProposal:createUnsolicitedProposal,
                normalActionText: Globals.SUBMIT_PROPOSAL,
            });
        }else if(popUpType === "Save"){
            setPopUpState({
                open: true,
                title: Globals.SAVE_AS_DRAFT_PROMPT_TITLE,
                text: Globals.SAVE_DRAFT_PROMPT,
                normalAction: updateFlag?()=>saveDraft({},updateFlag):saveDraft,
                normalActionText: Globals.SAVE_AS_DRAFT,
            });
        }
    }

    const validateField=(field='')=>{
        let newErrors=validateFields(false);
        if(newErrors[field]){
            let errorObj=errors;
            errorObj[field]=newErrors[field];
            setErrors(errorObj);
        }
    }
const [busyLoad,setBusy]=useState(false)
    const validateFields = (stateSet=true) => {
        const newErrors = {};

        if (!proposalTitle) newErrors.proposalTitle = 'Please enter proposal title';
        if (!productionType) newErrors.productionType = 'Please enter production type';
        if (!channel) newErrors.channel = 'Please enter channel';
        if (!cluster) newErrors.cluster = 'Please enter cluster';
        if (!country) newErrors.country = 'Please enter country';
        if (!scriptedUnscripted) newErrors.scriptedUnscripted = 'Please enter scripted/unscripted';
        if (!genre) newErrors.genre = 'Please enter genre';
        if (!currency) newErrors.currency = 'Please enter currency';
        if (!language) newErrors.language = 'Please enter language';
        if (!targetAudience) newErrors.targetAudience = 'Please enter target audience';
        if (!format) newErrors.format = 'Please enter format';
        
         if (genre==Globals.OTHER && !newGenre) newErrors.newGenre = 'Please enter ' + Globals.OTHER;
        if (formatTypes[format] === "E"){
            if (!noOfEpisodes  || parseFloat(noOfEpisodes)<=7) {
                (parseFloat(noOfEpisodes) <=7) ? newErrors.noOfEpisodes = 'Please enter a no. above 7' : newErrors.noOfEpisodes = 'Please enter no. of episodes';
            }
            if (!episodeDuration || parseFloat(episodeDuration)<=0) newErrors.episodeDuration = 'Please enter episode duration';
            if (!totalDuration) newErrors.totalDuration = 'Please enter total duration';
        }else if(formatTypes[format] === "M") {
                if (!noOfMiniEpisodes  || parseFloat(noOfMiniEpisodes)<=0 || parseFloat(noOfMiniEpisodes) > 7 ) {
                    (!noOfMiniEpisodes) ? newErrors.noOfMiniEpisodes = 'Please enter no. of episodes' : newErrors.noOfMiniEpisodes = 'please enter a no. from 1 to 7' ;
                }
                if (!episodeMiniDuration || parseFloat(episodeMiniDuration)<=0) newErrors.episodeMiniDuration = 'Please enter episode duration';
                if (!totalMiniDuration) newErrors.totalMiniDuration = 'Please enter total duration';
        }
        else if (formatTypes[format]=="D"){
            if (!duration  || parseFloat(duration)<=0) newErrors.duration = 'Please enter duration';
        }

        if (!synopsis) newErrors.synopsis = 'Please enter synopsis';
        if (!logline) newErrors.logline = 'Please enter logline';
        if (!targetBudget || parseFloat(targetBudget)<=0) newErrors.targetBudget = 'Please enter target budget';
        if (!productionSchedule) newErrors.productionSchedule = 'Please enter pitch deck';
        if (!episodeStructureOutline) newErrors.episodeStructureOutline = 'Please enter episode structure and outline';
        if (!locationStudioInfo) newErrors.locationStudioInfo = 'Please enter location and studio information';
        if (!castPresenterInfo) newErrors.castPresenterInfo = 'Please enter cast and presenter information';
        if (!brandIntegrationOpportunities) newErrors.brandIntegrationOpportunities = 'Please enter brand integration opportunities';
        if (!keyTeam) newErrors.keyTeam = 'Please enter key team';
        if(socialLinks.length){
            for (let i = 0; i < socialLinks.length; i++) {
                const link = socialLinks[i];

                    if(link && !validateSocialMediaLinks(link)){
                        newErrors["socialLinks"+i]="Please provide a valid social media link or leave it blank";
                    }
            }
        }

        stateSet && setErrors(newErrors);
        return newErrors;
    };
    const saveDraft = (params = {},updateFlag=false) => {
        if(updateFlag){
            updateUnsolicitedProposal(params, true);
        }else{ 
            createUnsolicitedProposal(params, true);
        }
    }
    const createUnsolicitedProposal = async (params, draftStatus = false) => {
        const noOfEpis= (formatTypes[format] === "E") ? (parseInt(noOfEpisodes) || 0) : (parseInt(noOfMiniEpisodes) || 0);
        const episDuration=(formatTypes[format] === "E") ? parseFloat(duration || episodeDuration || 0): parseFloat(duration || episodeMiniDuration || 0);
        let calcTotalEpisDuration=noOfEpis*episDuration;
        const requestBody = {
            proposalId: "00000000-0000-0000-0000-000000000000",
            title: proposalTitle,
            proposalType: 1,
            formatId: formatIds[format],
            languageId: languageIds[language],
            //regionId: 0,
            countryId: countryIds[country],
            channelId: channelIds[channel]||CryptoUtils.getFromLocalStorage("selectedChannelId"),
            genreId: genreIds[genre],
            //clusterId: clusterIds[cluster],
            productionTypeId: productionTypeIds[productionType],
            targetAudienceId: targetAudienceIds[targetAudience],
            currencyId: currencyIds[currency],
            proposalDetailId: 0,
            briefStatus: 0,
            contentTypeId: scriptTypesIds[scriptedUnscripted],
            description: "string",
            closingDate: "2025-01-28T08:46:03.506Z",
            producerId: producerId,
            logLine: logline,
            synopsis: synopsis,
            totalEpisodesDuration: calcTotalEpisDuration,
            noOfEpisodes: (formatTypes[format] === "E") ? (parseInt(noOfEpisodes) || 0) : (parseInt(noOfMiniEpisodes) || 0),
            totalDuration: (formatTypes[format] === "E") ? parseInt(totalDuration) || 0 : (parseFloat(totalMiniDuration) || 0),
            episodeDuration: (formatTypes[format] === "E") ? parseFloat(duration || episodeDuration || 0): parseFloat(duration || episodeMiniDuration || 0) || 0,
            otherGenre: newGenre,
            episodeStructure: (formatTypes[format] === "E" || formatTypes[format] === "M") ?episodeStructureOutline:'',
            castPresenterInfo: castPresenterInfo,
            locationStudioInfo: locationStudioInfo,
            brandIntegration: brandIntegrationOpportunities,
            keyTeams: keyTeam,
            productionTimeLine: productionSchedule,
            artistName: artistName,
            songName: songName,
            targetBudget: targetBudget, //&& parseFloat(targetBudget),
            status: draftStatus ? 1 : 0,
            projectStatus: projectStatus,
            submissionDate: "2025-01-28T08:46:03.506Z",
            referenceLinks: socialLinks.join(','),
            documents: [
                {
                    documentId: 0,
                    documentName: videoFile?.name,
                    documentType: videoFile?.type,
                    documentPath: videoFile?.path, 
                    // uploadedAt: new Date().toISOString(), 
                    documentFor: "VP" 
                },
                {
                    documentId: 1,
                    documentName: pdfFile?.name,
                    documentType: pdfFile?.type,
                    documentPath: pdfFile?.path,
                    // uploadedAt: new Date().toISOString(), 
                    documentFor: "PSH" 
                }
            ],
            createdBy: "612a8e8a-64af-4925-88bd-aef7893f3d55",
            updatedBy: "612a8e8a-64af-4925-88bd-aef7893f3d55",
            productionSchedule:pdfFile,
            videoPresentation:videoFile
        };
        if(proposalId){
          requestBody.proposalId=proposalId;
        }
        if(proposalDetailId){
          requestBody.proposalDetailId=proposalDetailId;
        }
        if(clusterIds[cluster]){
            requestBody.clusterId= clusterIds[cluster]
        }
        try {
            // setLoading(true)
            setBusy(true)
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            const response = await axios.post(Globals.ENDPOINT.CREATE_UNSOLICITED_PROPOSAL,requestBody,config);
            

            setLoading(false);
            setBusy(false)
            if (!response?.data?.status) {
                throw new Error('Network response was not ok');
            }
            if(response.data.content){
                if(response?.data?.status==Globals.BAD_REQ){
                    setPopUpState({
                        negativeAction: draftStatus?saveDraft:createUnsolicitedProposal,
                    });
                    setRegFailure({visible:true,status:draftStatus ? 1 : 0});
                }
            }
            if(response.data.status!=="OK"){
                setPopUpState({
                    negativeAction: draftStatus?saveDraft:createUnsolicitedProposal,
                });
                setRegFailure({visible:true,status:draftStatus ? 1 : 0});
              }
                  else if (response.data.content) {
                    setRegFailure(false);
                    // setLoading(true);
                    gotoMyProposals(response.data.content,draftStatus);
                  }
                  else {
                      setRegFailure({visible:true,status:draftStatus ? 1 : 0});
                  }
            console.log('Success:');
        } catch (error) {
            setLoading(false);
            setBusy(false)
            setPopUpState({
                negativeAction: draftStatus?saveDraft:createUnsolicitedProposal,
            });
            setRegFailure({visible:true,status:draftStatus ? 1 : 0})
            console.error('Error:', error);
        }
    };
    const updateUnsolicitedProposal = async (params, draftStatus = false) => {
        const noOfEpis= (formatTypes[format] === "E") ? (parseInt(noOfEpisodes) || 0) : (parseInt(noOfMiniEpisodes) || 0);
        const episDuration=(formatTypes[format] === "E") ? parseFloat(duration || episodeDuration || 0): parseFloat(duration || episodeMiniDuration || 0);
        let calcTotalEpisDuration=noOfEpis*episDuration;
        const requestBody = {
            proposalId: proposalId || "00000000-0000-0000-0000-000000000000",
            title: proposalTitle,
            proposalType: 1,
            formatId: formatIds[format],
            languageId: languageIds[language],
            //regionId: 0,
            countryId: countryIds[country],
            channelId: channelIds[channel],
            genreId: genreIds[genre],
            //clusterId: clusterIds[cluster],
            productionTypeId: productionTypeIds[productionType],
            targetAudienceId: targetAudienceIds[targetAudience],
            currencyId: currencyIds[currency],
            proposalDetailId: proposalDetailId || 0,
            // otherGenre:othergenre || null,
            briefStatus: 0,
            contentTypeId: scriptTypesIds[scriptedUnscripted],
            description: "string",
            closingDate: "2025-01-28T08:46:03.506Z",
            producerId: producerId,
            logLine: logline,
            synopsis: synopsis,
            totalEpisodesDuration: calcTotalEpisDuration,
            noOfEpisodes: (formatTypes[format] === "E") ? (parseInt(noOfEpisodes) || 0) : (parseInt(noOfMiniEpisodes) || 0),
            totalDuration: (formatTypes[format] === "E") ? parseInt(totalDuration) || 0 : (parseFloat(totalMiniDuration) || 0),
            episodeDuration: (formatTypes[format] === "E") ? parseFloat(duration || episodeDuration || 0): parseFloat(duration || episodeMiniDuration || 0) || 0,
            otherGenre: newGenre || null,
            episodeStructure: (formatTypes[format] === "E" || formatTypes[format] === "M") ?episodeStructureOutline:'',
            castPresenterInfo: castPresenterInfo,
            locationStudioInfo: locationStudioInfo,
            brandIntegration: brandIntegrationOpportunities,
            keyTeams: keyTeam,
            productionTimeLine: productionSchedule,
            artistName: artistName,
            songName: songName,
            targetBudget: targetBudget,// && parseFloat(targetBudget),
            status: draftStatus ? 1 : 0,
            projectStatus: projectStatus,
            submissionDate: "2025-01-28T08:46:03.506Z",
            referenceLinks: socialLinks.join(','),
            proposalDetailId,
            documents: [
                {
                    documentFor: "VP" ,
                    documentId: videoFile?.documentId || 0,
                    documentName: videoFile?.name,
                    documentType: videoFile?.type,
                    documentPath: videoFile?.path, 
                    uploadedAt: videoFile?.uploadedAt|| new Date().toISOString() 
                    
                },
                {
                    documentFor: "PSH" ,
                    documentId: pdfFile?.documentId || 1,
                    documentName: pdfFile?.name,
                    documentPath: pdfFile?.path, 
                    documentType: pdfFile?.type,
                    uploadedAt: pdfFile?.uploadedAt|| new Date().toISOString(), 
                    
                }
            ],
            createdBy: "612a8e8a-64af-4925-88bd-aef7893f3d55",
            updatedBy: "612a8e8a-64af-4925-88bd-aef7893f3d55",
            ...(!videoFile?.path && { productionSchedule:pdfFile,}),
            ...(!pdfFile?.path && { videoPresentation:videoFile }),
            
            
        };
        if(clusterIds[cluster]){
            requestBody.clusterId= clusterIds[cluster]
        }
        try {
            const config = {
                headers: {
                 'Content-Type': 'multipart/form-data' // Set the Content-Type header
                }
            };
            setBusy(true)
            // setLoading(true)
            const response = await axios.post(Globals.ENDPOINT.EDIT_UNSOLICITED_PROPOSAL,requestBody,config);
            
            setBusy(false)
            setLoading(false);
            if (!response?.data?.status) {
                throw new Error('Network response was not ok');
            }
            if(response.data.content){
                if(response?.data?.status==Globals.BAD_REQ){
                    handleBadReq(response.data?.content?.nullOrEmptyFields);
                    return;
                }
            }
            if(response.data.status!=="OK"){
                setPopUpState({
                    negativeAction: draftStatus?()=>{saveDraft({},true)}:updateUnsolicitedProposal,
                });
                setRegFailure({visible:true,status:draftStatus ? 1 : 0});
              }
                  else if (response.data.content) {
                    setRegFailure(false);
                    // setLoading(true);
                    gotoMyProposals(response.data.content,draftStatus);
                  }
                  else {
                      setRegFailure({visible:true,status:draftStatus ? 1 : 0});
                  }
            console.log('Success:');
        } catch (error) {
            setLoading(false);
            setBusy(false)
            setPopUpState({
                negativeAction: draftStatus?()=>{saveDraft({},true)}:updateUnsolicitedProposal,
            });
            setRegFailure({visible:true,status:draftStatus ? 1 : 0})
            console.error('Error:', error);
        }
    };
    const handleBadReq=(fields=[])=>{
        const newErrors = {};
        if(fields && fields.length){
            for (let i = 0; i < fields.length; i++) {
                const element = fields[i];
                newErrors[element]="It is a required field.";
            }
        }
        setErrors(newErrors);
        return newErrors;
    }
    const getUnsolicitedProposal = async (propId,load=true)=>{
        setLoading(true);
        try {
            const endpoint =Globals.ENDPOINT.GET_UNSOLICITED_PROPOSAL +"?"+"producerId="+producerId+"&"+"proposalId="+(proposalId || propId) ;
            const response = await axios.get(endpoint);
            

            load && setLoading(false);
            if (!response?.data?.status) {
                throw new Error('Network response was not ok');
            }
            if(response.data.content){
                return response.data.content;
            }
            console.log('Success:');
        } catch (error) {
            load && setLoading(false);
            console.error('Error:', error);
        }
    }
    return { errors, createUnsolicitedProposal, saveDraft,popUpState,openPopUp,setPopUpState,setErrors, loading,setLoading,busyLoad, getUnsolicitedProposal,isRegFailed,setRegFailure,setactiveHeader };
}
export default Unsolicited;